//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMargin = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let purchaseTextContainerMaxHeight = '20rem';
	let workoutContainerHeight = '20rem';
	let purchaseTextContainerPaddingX = '1rem';
	let purchaseAreaContainerHeight = '20rem';
	let payHereTextMarginTop = 0;
	//#endregion

	//#region seting vars based off params
	if (size === 'md') {
		workoutContainerHeight = '15rem';
		purchaseTextContainerMaxHeight = '15rem';
		purchaseAreaContainerHeight = '15rem';
	} else if (size === 'sm') {
		workoutContainerHeight = '15rem';
		purchaseTextContainerMaxHeight = '15rem';
		purchaseAreaContainerHeight = '15rem';
	}
	if (isMobile) {
		workoutContainerHeight = '20rem';
		purchaseAreaContainerHeight = 'auto';
		payHereTextMarginTop = '1rem';
	}
	//#endregion

	return {
		buyCourseContainer: () => {
			return {
				display: 'felx',
				flexDirection: 'column',
			};
		},
		topContentContainer: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
				marginLeft: `${minimumMargin}rem`,
				marginRight: `${minimumMargin}rem`,
			};
		},
		courseNameTitle: () => {
			return {
				color: 'black',
			};
		},
		workoutContainer: seeAll => {
			if (isMobile && seeAll) {
				workoutContainerHeight = '30rem';
			}
			return {
				height: workoutContainerHeight,
			};
		},
		purchaseAreaContainer: seeAll => {
			let height = seeAll ? 'auto' : purchaseAreaContainerHeight;
			return {
				display: 'flex',
				flexWrap: 'wrap',
				height: height,
				marginLeft: `${minimumMargin}rem`,
				marginRight: `${minimumMargin}rem`,
			};
		},
		purchaseTextContainer: seeAll => {
			let purchaseTextContainerPaddingXLeft = purchaseTextContainerPaddingX;
			let purchaseTextContainerPaddingXRight = purchaseTextContainerPaddingX;
			if (isMobile) {
				purchaseTextContainerPaddingXRight = '0';
			}
			if (isMobile && seeAll) {
				purchaseTextContainerPaddingXLeft = '0';
				purchaseTextContainerPaddingXRight = '0';
			}
			let maxHeight = seeAll ? 'unset' : purchaseTextContainerMaxHeight;
			return {
				display: 'flex',
				flexDirection: 'column',
				padding: `0 ${purchaseTextContainerPaddingXRight} 0 ${purchaseTextContainerPaddingXLeft}`,
				maxHeight: maxHeight,
			};
		},
		purchaseTextContainerClasses: seeAll => {
			let classes = 'col-6 col-sm-6';
			if (seeAll && isMobile) {
				classes += ' col-12';
			}

			return classes;
		},
		seeMoreDescriptionButton: () => {
			return {
				width: '8rem',
				marginTop: '1rem',
			};
		},
		priceText: seeAll => {
			let marginTop = '0rem';
			if (isMobile && seeAll) {
				marginTop = '1rem';
			}
			return {
				marginTop: marginTop,
			};
		},
		descriptionText: val => {
			let maxHeight = val ? 'unset' : '50%';

			let style = {
				marginTop: '1rem',
				textOverflow: `ellipsis`,
				overflow: `hidden`,
				maxHeight: maxHeight,
			};

			return style;
		},
		descriptionTextClass: seeAll => {
			let classes = '';
			if (isMobile && seeAll) {
				classes += ' col-12';
			}
			seeAll ? (classes += ' maxHeightAuto') : (classes += ' maxHeight50');
			return classes;
		},
		payHereText: () => {
			return {
				marginTop: payHereTextMarginTop,
			};
		},
		workoutContainerClasses: seeAll => {
			let classes = '';
			if (isMobile && seeAll) {
				classes = 'col-12';
			} else {
				classes = 'col-6 col-sm-2';
			}

			return classes;
		},
	};
}

export default Styles;
